import { FC } from 'react'
import { LinkEntityWidget } from 'Integrations/integrationsConfig/common/LinkEntities/LinkEntityWidget'
import { useLinkCustomerToService } from 'Integrations/integrationsConfig/common/LinkEntities/LinkCustomerToService/LinkCustomerToServiceWidget/useLinkCustomerToService'
import { LinkHubSpotDealModal } from './LinkHubSpotDealModal'
import { UnlinkHubSpotDealModal } from './UnlinkHubSpotDealModal'

export const LinkHubSpotDealWidget: FC<{
  quoteId: string
  customerId: string | undefined
  dealId: string | undefined
  dealUrl: string | undefined
  sequenceEntityLabel: string
  canLink: boolean
  canUnlink: boolean
  onLink: () => void
  onUnlink: () => void
}> = props => {
  const customerLink = useLinkCustomerToService({
    customerId: props.customerId ?? '',
    service: 'HubSpot',
    enabled: Boolean(props.customerId)
  })

  const sharedProps = {
    'data-testid': 'hubspot.linkDeal',
    sequenceEntityLabel: props.sequenceEntityLabel,
    externalEntityLabel: 'deal',
    serviceName: 'HubSpot'
  }

  const dealId = props.dealId

  if (dealId) {
    return (
      <LinkEntityWidget
        {...sharedProps}
        isLoaded
        linkedAccount={{
          label: `ID: ${dealId}`,
          href: props.dealUrl,
          canUnlink: props.canUnlink,
          isPending: false
        }}
        unlinkModal={({ onClose }) => (
          <UnlinkHubSpotDealModal
            dealId={dealId}
            onUnlink={props.onUnlink}
            onClose={onClose}
          />
        )}
      />
    )
  }

  if (!props.customerId) {
    return (
      <LinkEntityWidget
        {...sharedProps}
        isLoaded
        linkedAccount={null}
        showLinkButton={false}
        noLinkFoundText="Select a customer for this quote to link a HubSpot deal."
      />
    )
  }

  const linkedCompanyId = customerLink.linkedAccount.value

  if (!linkedCompanyId) {
    return (
      <LinkEntityWidget
        {...sharedProps}
        isLoaded={customerLink.isLoaded}
        linkedAccount={null}
        showLinkButton={false}
        noLinkFoundText="Link this customer to HubSpot before linking a deal."
      />
    )
  }

  return (
    <LinkEntityWidget
      {...sharedProps}
      isLoaded
      canLink={props.canLink}
      linkedAccount={null}
      linkModal={({ onClose }) => (
        <LinkHubSpotDealModal
          companyId={linkedCompanyId}
          quoteId={props.quoteId}
          onLink={props.onLink}
          onClose={onClose}
        />
      )}
    />
  )
}
